import {
  AccountPaymentVerificationResponseType,
  AuthType,
  GetAllAssignUserOfSingleClient,
  GetUserProfileType,
  LoginResponseType,
  UserProfileType,
} from "./authTypes";

export const initialState: AuthType = {
  fetching: false,
  attendenceFetching: false,
  managerFetching: false,
  internalFetching: false,
  externalFetching: false,
  internalUserCount: "",
  externalUserCount: "",
  message: null,
  error: null,
  attendenceError: null,
  attendenceSuccess: null,
  success: null,
  managerMessage: null,
  managerError: null,
  managerSuccess: null,
  partnerFetching: false,
  partnerSuccess: null,
  partnerStatusCode: null,
  partnerError: null,
  gotvOfficerFetching: false,
  govtOfficerSuccess: null,
  govtOfficerStatusCode: null,
  govtOfficerError: null,
  token: null,
  resetPasswordToken: null,
  loginData: {} as LoginResponseType,
  statusCode: null,
  attendanceStatusCode: null,
  managerStatusCode: null,
  userProfiledata: {} as GetUserProfileType,
  userProfileAllData: {} as UserProfileType,
  persistUserProfileAllData: {} as UserProfileType,
  userType: null,
  clientList: [],
  internalUsersList: [],
  externalUsersList: [],
  totalClientsCount: null,
  totalUserCount: "",
  totalManagerCount: "",
  totalPartnerCount: "",
  totalGovtOfficerCount: 0,
  isEmail: null,
  emailFetching: false,
  emailMessage: "",
  recruitmentTrackerUniqueEmailFetching: false,
  recruitmentTrackerUniqueEmailMessage: "",
  recruitmentTrackerUniqueMobileFetching: false,
  recruitmentTrackerUniqueMobileMessage: "",
  emailError: "",
  emailSatusCode: null,
  emailSuccess: null,
  isMobileNo: null,
  mobileFetching: false,
  mobileMessage: "",
  mobileError: "",
  currencySign: "",
  currencyName: "",
  currencyShortForm: "",
  mobileSatusCode: null,
  mobileSuccess: null,
  userDetails: [],
  individualClientList: [],
  assignedClientsToUserList: [],
  favouriteClientsData: [],
  unFavouriteClientsData: [],
  finacUsersList: [],
  finacManagerList: [],
  finacPartnerList: [],
  finacGovtOfficerList: [],
  finacClientsList: [],
  finacClientUsersList: [],
  clientCodeList: [],
  sideMenus: [],
  modules: [],
  others: [],
  allGroupMenus: [],
  allAssignUserOfSingleClient: {} as GetAllAssignUserOfSingleClient,
  attendenceData: [],
  totalAttendanceHours: 0,
  latitude: "",
  longitude: "",
  location: "",
  locationCityName: "",
  totalUnfavouriteClient: 0,
  companyName: "",
  isSignupEmail: null,
  signUpEmailFetching: false,
  signUpEmailMessage: "",
  signUpEmailError: "",
  signUpEmailSatusCode: null,
  signUpEmailSuccess: null,
  isSignUpMobileNo: null,
  signUpMobileFetching: false,
  singUpMobileMessage: "",
  signUpMobileError: "",
  signUpMobileSatusCode: null,
  signUpMobileSuccess: null,
  countryList: [],
  countryListTotalCount: 0,
  countryFetching: false,
  stateList: [],
  stateListTotalCount: 0,
  isState: null,
  stateFetching: false,
  cityList: [],
  cityListTotalCount: 0,
  cityFetching: false,
  isCity: null,
  teamDirectoryUsersData: [],
  totalTeamDirectoryUsersCount: 0,
  countrySuccess: null,
  countryError: "",
  stateSuccess: null,
  stateError: "",
  citySuccess: null,
  cityError: "",
  govtOfficerJobsList: [],
  totalJobListCount: 0,
  auAccountNumberVerifyData: {},
  auAccountNumberFetching: false,
  specificPincodeInformation: [],
  verifyVoucherMessage: null,
  verifyVoucherSuccess: null,
  isAccountNumberVerified: false,
  accountPaymentVoucherVerification: {} as AccountPaymentVerificationResponseType,
  isVoucherCodeVerified: false,
  verifyAccountNumberMessage:null

};
